"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
class MessageRef {
    constructor(timestamp, sequenceNumber) {
        (0, validations_1.validateIsNotNegativeInteger)('timestamp', timestamp);
        (0, validations_1.validateIsNotNegativeInteger)('sequenceNumber', sequenceNumber, true);
        this.timestamp = timestamp;
        this.sequenceNumber = sequenceNumber;
    }
    compareTo(other) {
        if (this.timestamp < other.timestamp) {
            return -1;
        }
        if (this.timestamp > other.timestamp) {
            return 1;
        }
        if (this.sequenceNumber < other.sequenceNumber) {
            return -1;
        }
        if (this.sequenceNumber > other.sequenceNumber) {
            return 1;
        }
        return 0;
    }
    toArray() {
        return [
            this.timestamp,
            this.sequenceNumber,
        ];
    }
    static fromArray(arr) {
        const [timestamp, sequenceNumber,] = arr;
        return new MessageRef(timestamp, sequenceNumber);
    }
    serialize() {
        return JSON.stringify(this.toArray());
    }
    clone() {
        return new MessageRef(this.timestamp, this.sequenceNumber);
    }
}
exports.default = MessageRef;
//# sourceMappingURL=MessageRef.js.map